// extracted by mini-css-extract-plugin
module.exports = {"warningText":"WarningText_warningText__1pILD","warningIcon":"WarningText_warningIcon__3K1Sg"};